import { ref } from 'vue';
import type { OfferDto } from '../types/offer.types';
import { useApiConfig } from '../../../composables/useApi';
import { offersApi } from '../services/offers.api';

export function useEditMode() {
  const editing = ref(false);
  const currentOffer = ref<OfferDto | null>(null);
  const api = useApiConfig();

  const startCreate = () => {
    currentOffer.value = null;
    editing.value = true;
  };
  const startEdit = async (o: OfferDto) => {
    // Show form immediately with known data, fill in images/details asynchronously
    currentOffer.value = o;
    editing.value = true;

    try {
      if (!o.images || o.images.length === 0) {
        const res = await offersApi.listWithConfig(api, { id: o.id });
        const detailed = Array.isArray(res?.data) ? res.data.find(x => x.id === o.id) : (res as any)?.data;
        if (detailed) currentOffer.value = detailed as OfferDto;
      }
    } catch (e) {
      console.warn('Could not fetch offer details, using list item', e);
    }
  };
  const cancelEdit = () => {
    currentOffer.value = null;
    editing.value = false;
  };

  return { editing, currentOffer, startCreate, startEdit, cancelEdit };
}
